(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stu-flavor-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('stu-flavor-gallery')) {
  customElements.define('stu-flavor-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;
      this.panels = Array.from(this.querySelectorAll('[data-stu-gallery-panel]'));
      if (!this.panels.length) return;
      this.track = this.querySelector('[data-stu-gallery-track]');
      this.triggers = this.panels.map((panel) => panel.querySelector('[data-stu-gallery-trigger]'));
      this.previousButton = this.querySelector('[data-stu-gallery-previous]');
      this.nextButton = this.querySelector('[data-stu-gallery-next]');
      this.mobileQuery = matchMedia('(max-width: 749px)');
      this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
      this.hoverQuery = matchMedia('(hover: hover) and (pointer: fine)');
      this.activeIndex = Math.max(0, this.panels.findIndex((panel) => panel.classList.contains('is-active')));
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-stu-gallery-trigger]');
        const index = this.triggers.indexOf(trigger);
        if (index !== -1) this.openPanel(index);
        if (event.target.closest('[data-stu-gallery-previous]')) this.moveCard(-1);
        if (event.target.closest('[data-stu-gallery-next]')) this.moveCard(1);
      }, options);
      this.addEventListener('focusin', (event) => {
        const index = this.triggers.indexOf(event.target);
        if (index !== -1 && !this.mobileQuery.matches) this.openPanel(index);
      }, options);
      this.addEventListener('pointerover', (event) => {
        if (this.mobileQuery.matches || !this.hoverQuery.matches || event.pointerType !== 'mouse') return;
        if (this.contains(document.activeElement)) return;
        const panel = event.target.closest('[data-stu-gallery-panel]');
        const index = this.panels.indexOf(panel);
        if (index !== -1 && !panel.contains(event.relatedTarget)) this.openPanel(index);
      }, options);
      this.addEventListener('keydown', (event) => {
        const index = this.triggers.indexOf(event.target);
        if (index === -1 || this.mobileQuery.matches) return;
        let nextIndex = index;
        const isRtl = getComputedStyle(this).direction === 'rtl';
        if (event.key === 'ArrowRight') nextIndex += isRtl ? -1 : 1;
        else if (event.key === 'ArrowLeft') nextIndex += isRtl ? 1 : -1;
        else if (event.key === 'ArrowDown') nextIndex += 1;
        else if (event.key === 'ArrowUp') nextIndex -= 1;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = this.panels.length - 1;
        else return;
        event.preventDefault();
        nextIndex = (nextIndex + this.panels.length) % this.panels.length;
        this.openPanel(nextIndex);
        this.triggers[nextIndex].focus({ preventScroll: true });
      }, options);
      document.addEventListener('shopify:block:select', (event) => {
        const index = this.panels.findIndex((panel) => panel.dataset.blockId === event.detail?.blockId);
        if (index === -1) return;
        if (this.mobileQuery.matches) this.scrollToCard(index);
        else this.openPanel(index);
      }, options);
      this.mobileQuery.addEventListener('change', () => this.syncLayout(), options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => this.syncNavigation());
      }, { ...options, passive: true });
      this.classList.add('is-ready');
      this.syncLayout();
    }
    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
      cancelAnimationFrame(this.scrollFrame);
    }
    syncLayout() {
      if (this.mobileQuery.matches) {
        this.panels.forEach((panel, index) => {
          panel.querySelector('[data-stu-gallery-content]').hidden = false;
          this.triggers[index].setAttribute('aria-expanded', 'true');
          this.triggers[index].setAttribute('aria-disabled', 'true');
        });
        this.syncNavigation();
      } else {
        this.openPanel(this.activeIndex);
      }
    }
    openPanel(index) {
      this.activeIndex = index;
      if (this.mobileQuery.matches) return;
      this.panels.forEach((panel, panelIndex) => {
        const isActive = panelIndex === index;
        const trigger = this.triggers[panelIndex];
        const content = panel.querySelector('[data-stu-gallery-content]');
        panel.classList.toggle('is-active', isActive);
        trigger.setAttribute('aria-expanded', String(isActive));
        if (isActive) trigger.setAttribute('aria-disabled', 'true');
        else trigger.removeAttribute('aria-disabled');
        content.hidden = !isActive;
      });
    }
    currentCard() {
      const trackBounds = this.track.getBoundingClientRect();
      const isRtl = getComputedStyle(this).direction === 'rtl';
      const edge = isRtl ? 'right' : 'left';
      let closestIndex = 0;
      let closestDistance = Infinity;
      this.panels.forEach((panel, index) => {
        const distance = Math.abs(panel.getBoundingClientRect()[edge] - trackBounds[edge]);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });
      return closestIndex;
    }
    syncNavigation() {
      if (!this.mobileQuery.matches) return;
      const index = this.currentCard();
      this.previousButton.disabled = index === 0;
      this.nextButton.disabled = index === this.panels.length - 1;
    }
    moveCard(direction) {
      this.scrollToCard(Math.min(this.panels.length - 1, Math.max(0, this.currentCard() + direction)));
    }
    scrollToCard(index) {
      this.panels[index].scrollIntoView({
        behavior: this.motionQuery.matches ? 'instant' : 'smooth',
        block: 'nearest',
        inline: 'start'
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stu-ireland-moments"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('stu-ireland-moments')) {
  customElements.define('stu-ireland-moments', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const track = this.querySelector('.stu-moments-track');
      const buttons = this.querySelectorAll('button[data-direction]');
      const update = () => {
        buttons[0].disabled = track.scrollLeft < 3;
        buttons[1].disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 3;
      };
      buttons.forEach(button => button.addEventListener('click', () => {
        const card = track.querySelector('li');
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        track.scrollBy({left:(card.getBoundingClientRect().width + gap) * Number(button.dataset.direction),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }));
      track.addEventListener('scroll', update, {passive:true});
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      update();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stu-motion-strip"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('stu-motion-strip')) {
  customElements.define('stu-motion-strip', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.control = this.querySelector('.stu-motion-strip__control');
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.classList.add('is-paused');
        this.control.hidden = true;
      }
      this.control.addEventListener('click', () => {
        const paused = this.classList.toggle('is-paused');
        this.control.setAttribute('aria-pressed', String(paused));
        this.control.textContent = paused ? this.dataset.playLabel : this.dataset.pauseLabel;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stu-podcast-editorial"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('stu-podcast-player')) {
  customElements.define('stu-podcast-player', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';
      const button = this.querySelector('button');
      const template = this.querySelector('template');
      const mount = this.querySelector('.stu-podcast-player__mount');
      if (!button || !template || !mount) return;
      button.addEventListener('click', () => {
        mount.appendChild(template.content.cloneNode(true));
        this.classList.add('is-loaded');
        const frame = mount.querySelector('iframe');
        if (frame) frame.focus();
      }, { once: true });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stu-television-editorial"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('stu-tv-reel')) {
    customElements.define('stu-tv-reel', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.addEventListener('click', (event) => {
          if (!event.target.closest('[data-stu-tv-load]') || this.hasAttribute('data-loaded')) return;
          const template = this.querySelector('template');
          const mount = this.querySelector('.stu-tv-player__mount');
          if (!template || !mount) return;
          mount.appendChild(template.content.cloneNode(true));
          this.setAttribute('data-loaded', '');
          const frame = mount.querySelector('iframe');
          if (frame) frame.focus();
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
